import { isDefinedArray, reduce } from "et3-type-guards";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import i18n from "../../../../../constants/i18n";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import getApproveRejectStore from "../../../../../stores/approval-reject-store";
import { countActivePictures } from "../../../../../stores/approval-reject-store/approval-item-counts";
import { TApprovalAlbumPicture, TUserEntry } from "../../../../../Types";
import ApprovalChip from "../../ApprovalChip";
import { APPROVAL_SOFT_DELETED } from "../../approval-data-constants";
import LaneHeader from "./LaneHeader";
import PictureTile from "./PictureTile";
import {
  NO_PICTURES_FONT_SIZE,
  NO_PICTURES_GAP,
  NO_PICTURES_HEIGHT,
  NO_PICTURES_ICON,
  NO_PICTURES_PADDING,
  NO_PICTURES_RADIUS_CSS,
  TILE_GAP
} from "./lane-constants";

const PicturesLane = withLiteObserverAndTheme<{ userEntry: TUserEntry }>(
  (props) => {
    const { userEntry, theme } = props;
    const { colors, unitX, unitY } = theme;
    const albumPicture = reduce<TApprovalAlbumPicture[]>(
      () => userEntry.albumPicture,
      []
    );
    const userId = reduce(() => userEntry.user_id, -1);
    const userUUID = reduce(() => userEntry.userUUID, "");
    const totalCount = countActivePictures(userEntry);
    const hasPictures = isDefinedArray(albumPicture) && totalCount > 0;
    const orderedPictures = getApproveRejectStore().orderedAlbumPictureArray(
      userEntry.albumPicture
    );

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={0}
        fDirection="column"
        alignItems="stretch"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{ width: "100%", minWidth: 0 }}
        onClick={() => {}}
      >
        <LaneHeader titleKey={"PICTURES"}>
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            withShadow={false}
            width={0}
            height={0}
            fDirection="row"
            alignItems="center"
            justifyContent="flex-start"
            color={colors.all.transparent}
            style={{
              flex: 1,
              width: "auto",
              minWidth: 0,
              height: "auto",
              minHeight: 0
            }}
            onClick={() => {}}
          />
          {hasPictures ? (
            <ApprovalChip
              label={i18n.getWithExtraData(
                "APPROVAL_TOTAL_COUNT",
                `${totalCount}`
              )}
              toneColor={colors.all.gray}
              backgroundColor={APPROVAL_SOFT_DELETED}
            />
          ) : null}
        </LaneHeader>

        {hasPictures ? (
          <ET3Div
            isScrollable={true}
            isExtendable={true}
            withShadow={false}
            width={0}
            height={0}
            fDirection="row"
            alignItems="flex-start"
            justifyContent="flex-start"
            color={colors.all.transparent}
            style={{
              width: "100%",
              minWidth: 0,
              gap: TILE_GAP * unitX,
              overflowY: "hidden"
            }}
            onClick={() => {}}
          >
            {orderedPictures.map((picture) => {
              return (
                <PictureTile
                  key={reduce(() => picture.id, 0)}
                  picture={picture}
                  userId={userId}
                  userUUID={userUUID}
                />
              );
            })}
          </ET3Div>
        ) : (
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            withShadow={false}
            width={0}
            height={NO_PICTURES_HEIGHT}
            fDirection="row"
            alignItems="center"
            justifyContent="flex-start"
            color={colors.all.paleBluishGray}
            style={{
              boxSizing: "border-box",
              width: "100%",
              minWidth: 0,
              borderRadius: NO_PICTURES_RADIUS_CSS,
              paddingLeft: NO_PICTURES_PADDING * unitX,
              paddingRight: NO_PICTURES_PADDING * unitX,
              gap: NO_PICTURES_GAP * unitX
            }}
            onClick={() => {}}
          >
            <FontAwesomeIcon
              icon={faCamera}
              color={colors.all.gray}
              style={{
                width: NO_PICTURES_ICON * unitX,
                height: NO_PICTURES_ICON * unitY
              }}
            />
            <Et3Text
              fontFamily={"LIGHT"}
              fontSize={NO_PICTURES_FONT_SIZE}
              text={i18n.get("NO_PICTURES_UPLOADED")}
              isSpan={true}
              color={colors.all.gray}
              style={{ margin: 0 }}
            />
          </ET3Div>
        )}
      </ET3Div>
    );
  }
);
export default PicturesLane;
